'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('../../../constants/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockShieldIcon = function (_React$Component) {
    _inherits(LockShieldIcon, _React$Component);

    function LockShieldIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, LockShieldIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LockShieldIcon.__proto__ || Object.getPrototypeOf(LockShieldIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary, secondary) {
            return _react2.default.createElement(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 78 78' },
                _react2.default.createElement(
                    'g',
                    { id: 'streamline-icon-lock-shield_40x40_1_', 'data-name': 'streamline-icon-lock-shield@40x40 (1)', transform: 'translate(1.25 1.25)' },
                    _react2.default.createElement('path', { id: 'Path_42459', 'data-name': 'Path 42459', fill: 'none', stroke: primary, d: 'M16.283,16.25H41.45a5.035,5.035,0,0,1,5.033,5.033v15.1a5.035,5.035,0,0,1-5.033,5.033H16.283a5.035,5.035,0,0,1-5.033-5.033v-15.1A5.035,5.035,0,0,1,16.283,16.25Z', transform: 'translate(8.883 13.95)', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', strokeWidth: '2.5' }),
                    _react2.default.createElement('path', { id: 'Path_42460', 'data-name': 'Path 42460', fill: 'none', stroke: primary, d: 'M20.633,21.875a1.255,1.255,0,1,0,.007,0h-.007', transform: 'translate(17.117 19.65)', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', strokeWidth: '2.5' }),
                    _react2.default.createElement('path', { id: 'Path_42461', 'data-name': 'Path 42461', fill: 'none', stroke: primary, d: 'M13.75,26.383v-7.55a12.583,12.583,0,0,1,25.167,0v7.55', transform: 'translate(11.417 3.817)', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', strokeWidth: '2.5' }),
                    _react2.default.createElement('path', { id: 'Path_42462', 'data-name': 'Path 42462', fill: 'none', stroke: secondary, d: 'M39,76.75C16.6,70.774,1.25,57.489,1.25,33.967V1.25h75.5V33.967C76.75,57.472,61.425,70.767,39,76.75Z', transform: 'translate(-1.25 -1.25)', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', strokeWidth: '2.5' })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(LockShieldIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || 78;
            return this.getIcon(size, size, _colors.Colors.Primary, _colors.Colors.Secondary);
        }
    }]);

    return LockShieldIcon;
}(_react2.default.Component);

exports.default = LockShieldIcon;